module.exports = __webpack_public_path__ + "2021bae12d3550c46f25d7de3b986194.png";